import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/app/applications")({
  component: () => <Navigate to="/app/jobs" replace />,
});
